import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import ReactMoment from "react-moment";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import qs from "qs";
import { STORE_GRU_SAVING_LIST_QUERY } from "../Queries";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../Components/Panel/Panel";
import Pagination from "../../../../Components/Pagination/QSP";
import { currencyName } from "../../../../Components/User/UserNames";
import { graphqlUri } from "../../../../Config/Env";

const blockSize = 5;
const first = 15;

const pad = (n) => String(n).padStart(2, "0");
const fmtDate = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// 기간 빠른 선택 (상점결제내역과 동일)
const periodButtons = [
  { id: "ALL", name: "전체" },
  { id: 1, name: "1개월" },
  { id: 3, name: "3개월" },
  { id: 6, name: "6개월" },
  { id: 12, name: "12개월" },
];

export default withRouter(({ location, history }) => {
  const queryString = qs.parse(location.search.substr(1));
  const page = queryString.page ? parseInt(queryString.page) : 1;

  const today = new Date();

  const startSearchDate = queryString.startSearchDate || "2020-09-01";
  const endSearchDate = queryString.endSearchDate || fmtDate(today);
  const commonStatus = queryString.commonStatus || "";
  const skip = first * (page - 1);

  const [startDate, setStartDate] = useState(startSearchDate);
  const [endDate, setEndDate] = useState(endSearchDate);

  useEffect(() => {
    setStartDate(startSearchDate);
    setEndDate(endSearchDate);
  }, [startSearchDate, endSearchDate]);

  const { data, loading, error } = useQuery(STORE_GRU_SAVING_LIST_QUERY, {
    variables: {
      commonStatus: commonStatus || undefined,
      startSearchDate: startSearchDate || undefined,
      endSearchDate: endSearchDate || undefined,
      skip,
      first,
    },
    fetchPolicy: "network-only",
  });

  const params = () =>
    (commonStatus ? `commonStatus=${commonStatus}&` : "") +
    (startDate ? `startSearchDate=${startDate}&` : "") +
    (endDate ? `endSearchDate=${endDate}&` : "");

  const onSearch = () => {
    history.push(`/storeGruSavings?${params()}page=1`);
  };

  const onStatus = (status) => {
    history.push(
      `/storeGruSavings?${status ? `commonStatus=${status}&` : ""}` +
        (startSearchDate ? `startSearchDate=${startSearchDate}&` : "") +
        (endSearchDate ? `endSearchDate=${endSearchDate}&` : "") +
        "page=1"
    );
  };

  const onPeriod = (id) => {
    const end = fmtDate(today);
    let start = "2020-09-01";
    if (id !== "ALL") {
      const d = new Date();
      d.setMonth(d.getMonth() - id);
      start = fmtDate(d);
    }
    history.push(
      `/storeGruSavings?${commonStatus ? `commonStatus=${commonStatus}&` : ""}` +
        `startSearchDate=${start}&endSearchDate=${end}&page=1`
    );
  };

  const onExcel = async () => {
    const token = localStorage.getItem("token");
    const query =
      (commonStatus ? `commonStatus=${commonStatus}&` : "") +
      (startSearchDate ? `startDate=${startSearchDate}&` : "") +
      (endSearchDate ? `endDate=${endSearchDate}&` : "");
    const res = await fetch(`${graphqlUri}/excels/gruSavings?${query}`, {
      method: "POST",
      mode: "cors",
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    if (!res.ok) {
      const msg = await res.text();
      toast.error(msg || "엑셀 다운로드에 실패했습니다.");
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "그루적립내역.xlsx";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    a.remove();
  };

  const baseUrl = `/storeGruSavings?${params()}`;

  const result = !error && data && data.StoreGruSavingList;
  const gruSavings = result ? result.gruSavings : [];
  const count = result ? result.count : 0;
  const totalAmount = result ? result.totalAmount : 0;

  return (
    <>
      <Helmet>
        <title>그루 적립내역 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item active">그루 적립내역</li>
        </ol>
        <h1 className="page-header">그루 적립내역</h1>

        <Panel>
          <PanelHeader noButton={true}>
            그루 적립내역 ({count}건)
            {totalAmount > 0 && (
              <span className="m-l-10 f-s-13 text-white-transparent-8">
                실적립 합계{" "}
                <NumberFormat
                  value={totalAmount}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                그루
              </span>
            )}
          </PanelHeader>
          <PanelBody>
            {error && (
              <div className="alert alert-warning">
                그루 적립내역을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.
              </div>
            )}

            <div className="row m-b-10">
              <div className="col-md-3 m-b-5">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3 m-b-5">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2 m-b-5">
                <button className="btn btn-primary btn-block" onClick={onSearch}>
                  검색
                </button>
              </div>
              <div className="col-md-2 m-b-5">
                <button className="btn btn-white btn-block" onClick={onExcel}>
                  <i className="fa fa-download m-r-5"></i>엑셀
                </button>
              </div>
            </div>

            <div className="row m-b-10">
              <div className="col-md-12 m-b-5">
                {periodButtons.map((p) => (
                  <button
                    key={p.id}
                    className="btn btn-white m-r-5"
                    onClick={() => onPeriod(p.id)}
                  >
                    {p.name}
                  </button>
                ))}
                <span className="m-l-10">
                  <button
                    className={`btn m-r-5 ${
                      commonStatus === "" ? "btn-primary" : "btn-white"
                    }`}
                    onClick={() => onStatus("")}
                  >
                    전체
                  </button>
                  <button
                    className={`btn m-r-5 ${
                      commonStatus === "C" ? "btn-primary" : "btn-white"
                    }`}
                    onClick={() => onStatus("C")}
                  >
                    적립완료
                  </button>
                  <button
                    className={`btn ${
                      commonStatus === "D" ? "btn-primary" : "btn-white"
                    }`}
                    onClick={() => onStatus("D")}
                  >
                    취소
                  </button>
                </span>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>적립정보</th>
                    <th>회원명</th>
                    <th>아이디</th>
                    <th>적립금액</th>
                    <th>적립일시</th>
                  </tr>
                </thead>
                <tbody>
                  {(loading || count === 0) && (
                    <tr>
                      <td colSpan={6} className="text-center">
                        {loading ? "불러오는 중..." : "그루 적립내역이 없습니다."}
                      </td>
                    </tr>
                  )}
                  {!loading &&
                    gruSavings.map((item) => (
                      <tr key={item.id}>
                        <td>
                          {item.commonStatus === "C" ? (
                            <span className="label label-success">적립완료</span>
                          ) : (
                            <span className="label label-default">취소</span>
                          )}
                        </td>
                        <td>
                          {item.gruSavingInfo ? item.gruSavingInfo.name : "-"}
                        </td>
                        <td>{item.user ? item.user.name : "-"}</td>
                        <td>{item.user ? item.user.userId : "-"}</td>
                        <td align="right">
                          <NumberFormat
                            value={item.amount}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                          {currencyName(item.currency)}
                        </td>
                        <td>
                          <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                            {item.createdAt}
                          </ReactMoment>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
          {count > 0 && (
            <PanelFooter>
              <Pagination
                totalRecord={count}
                blockSize={blockSize}
                pageSize={first}
                currentPage={page}
                baseUrl={baseUrl}
              />
            </PanelFooter>
          )}
        </Panel>
      </div>
    </>
  );
});
